import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { useNavigate, useLocation } from 'react-router-dom';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    if (!isHomePage) {
      // Se não estiver na home, navega primeiro
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      // Se já estiver na home, apenas faz scroll
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setIsMobileMenuOpen(false);
  };

  const handleLogoClick = () => {
    navigate('/');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md py-3' : 'bg-white/95 backdrop-blur-sm py-4'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center cursor-pointer" onClick={handleLogoClick}>
            <img
              src="https://customer-assets.emergentagent.com/job_industrial-supply-20/artifacts/skys35hx_SSA_FULL_.png"
              alt="SSA Distribuidora"
              className="h-14 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('sobre')}
              className="text-gray-700 hover:text-red-600 font-medium transition-colors duration-200"
            >
              Sobre
            </button>
            <button
              onClick={() => scrollToSection('proposito')}
              className="text-gray-700 hover:text-red-600 font-medium transition-colors duration-200"
            >
              Propósito
            </button>
            <a
              href="https://www.vhsys.net/ssadistribuidora"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gradient-to-r from-red-600 to-red-700 text-white px-6 py-2.5 rounded-lg font-semibold hover:from-red-700 hover:to-red-800 transition-all duration-300 shadow-lg hover:shadow-xl flex items-center gap-2"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
              </svg>
              Loja Virtual
            </a>
            <button
              onClick={() => scrollToSection('localizacao')}
              className="text-gray-700 hover:text-red-600 font-medium transition-colors duration-200"
            >
              Localização
            </button>
            <Button
              onClick={() => scrollToSection('contato')}
              className="bg-gray-700 hover:bg-gray-800 text-white transition-all duration-300"
            >
              Fale Conosco
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-700 hover:text-red-600 transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 space-y-3 animate-in slide-in-from-top duration-200">
            <button
              onClick={() => scrollToSection('sobre')}
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-red-600 rounded transition-colors"
            >
              Sobre
            </button>
            <button
              onClick={() => scrollToSection('proposito')}
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-red-600 rounded transition-colors"
            >
              Propósito
            </button>
            <a
              href="https://www.vhsys.net/ssadistribuidora"
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full bg-gradient-to-r from-red-600 to-red-700 text-white px-4 py-3 rounded-lg font-semibold text-center"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              🛒 Loja Virtual
            </a>
            <button
              onClick={() => scrollToSection('localizacao')}
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-red-600 rounded transition-colors"
            >
              Localização
            </button>
            <Button
              onClick={() => scrollToSection('contato')}
              className="w-full bg-gray-700 hover:bg-gray-800 text-white"
            >
              Fale Conosco
            </Button>
          </nav>
        )}
      </div>
    </header>
  );
};